import { styled } from '@mui/material/styles';
import { Button, Icon } from '@mui/material';

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'variant',
})(({ variant }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: variant === 'passFail' ? 'row' : 'column',
  width: '100%',
  alignItems: 'center',
}));

export const ToggleButton = styled(Button, {
  shouldForwardProp: (prop) => !['variant', 'isSelected'].includes(prop),
})(({ theme, variant }) => ({
  width: '100%',
  backgroundColor: theme.palette.action.disabledBackground,
  borderRadius: 10,
  borderLeftWidth: 5,
  borderColor: 'red',
  borderLeftStyle: 'solid',
  marginBottom: 1,
  textAlign: 'left',
  minHeight: 50,
  marginRight: variant === 'passFail' ? 5 : 0,
  justifyContent: 'flex-start',
  fontWeight: 'normal',
  color: theme.palette.text.primary,
}));

export const BtnText = styled('span')({
  fontWeight: 'normal',
  fontSize: 12,
});

export const OptNumber = styled('span')({
  fontWeight: 'bold',
  fontSize: 15,
  marginRight: 10,
});

export const ToggleIcon = styled(Icon)({
  marginRight: 5,
});

export const ActiveWrap = styled('div')(({ theme }) => ({
  border: '5px solid transparent',
  borderRadius: 10,
  boxShadow: '-5px 0px 0px 0px',
  margin: '9px 0',
  position: 'relative',
  width: '100%',

  '& .activetext': {
    position: 'absolute',
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
    top: -14,
    left: 16,
    fontSize: 12,
    padding: '0px 3px',
    '.right': {
      left: -36,
    },
  },
}));

export const RowWrap = styled('div')({
  width: '100%',
});
